<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Kategori Retribusi</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'instanceServicesCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'adminServices' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Kategori Retribusi
                </h4>
            </div>
        </div>
    </div>

    <div>
        <form @submit.prevent="submitForm()">
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataService.name.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Nama Kategori Retribusi</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataService.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataService.name.required">Nama Kategori Retribusi wajib diisi</div>
                    </div>

                    <div v-if="companySetting">
                        <div class="form-group">
                            <label for="example-text-input" class="col-form-label text-left d-block">Pilih Kategori</label>
                            <select class="form-control select-2-form" id="select-2-form" :disabled="loading"
                                v-model="dataService.category_service_item_master_data_id" v-select2>
                                <option value="" selected>--- Pilih Form ----</option>
                                <option :value="item.id" v-for="item in dataMasterData.items" :key="item.id"
                                    :selected="item.id == dataService.category_service_item_master_data_id">
                                    {{item.value}}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="form-group" :class="{ 'is-invalid': $v.dataService.price.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Harga</label>
                        <input type="number" class="form-control" placeholder="Masukkan Harga" 
                        v-model.trim="$v.dataService.price.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataService.price.required">Harga wajib diisi</div>
                        <div class="error" v-if="!$v.dataService.price.number">Harga harus berupa nomor</div>
                        <div class="error" v-if="!$v.dataService.price.minValue">Harga minimal adalah 0</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataService.unit.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Satuan</label>
                        <input type="number" class="form-control" placeholder="Contoh. 1" 
                        value="1"
                        v-model.trim="$v.dataService.unit.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataService.unit.required">Satuan wajib diisi</div>
                        <div class="error" v-if="!$v.dataService.unit.number">Satuan harus berupa nomor</div>
                        <div class="error" v-if="!$v.dataService.unit.minValue">Satuan minimal adalah 0</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataService.unit_type.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Tipe Satuan</label>
                        <input type="text" class="form-control" placeholder="Contoh. m3" 
                        v-model.trim="$v.dataService.unit_type.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataService.unit_type.required">Tipe Satuan wajib diisi</div>
                    </div>

                    <div class="form-group mb-0">
                        <div class="custom-control custom-switch switch-primary">
                            <input type="checkbox" class="custom-control-input" id="customSwitchPrimary" v-model="dataService.is_editable_price">
                            <label class="custom-control-label" for="customSwitchPrimary">Harga dapat diubah</label>
                        </div>
                    </div>
                </div>
            </div>


            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Kategori Retribusi
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { required, integer, minValue } from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                loading: false,
                dataService: {
                    name: '',
                    form_template_id: '',
                    category_service_item_master_data_id: '',
                    price: 0,
                    unit: 1,
                    unit_type: null,
                    is_editable_price: false
                },
                dataFormEngine: [],
                dataMasterData: [],
                companySetting: null,
            };
        },
        validations: {
            dataService: {
                name: {
                    required,
                },
                price: {
                    integer,
                    required,
                    minValue: minValue(0)
                },
                unit: {
                    integer,
                    required,
                    minValue: minValue(0)
                },
                unit_type: {
                    required
                }
            }
        },
        methods: {
            // LOAD ALL REQUIRED DATA BEFORE USING FORM
            async initialLoad() {
                // MASTER DATA FORM
                try {
                    // const companySetting = await this.$http.get(`${this.API_URL}company-setting`, {
                    //     headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    // })
                    
                    // const setting = companySetting.data.data.category_service_master_data_id
                    // this.companySetting = setting

                    // if(setting){
                    //     const master_data = await this.$http.get(`${this.API_URL}master-data/${setting}`, {
                    //         headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    //     })

                    //     this.dataMasterData = master_data.data.data
                    // }
                } catch (error) {
                    this.errorHandler(error)
                }
                
                // DATA FORM TEMPLATE
                const formTemplate = this.$http.get(`${this.API_URL}administrator/form-template/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then((responseForm) => {
                    const resultForm = responseForm.data;
                    if (resultForm.success) {
                        this.dataFormEngine = resultForm.data.filter(item => item.form_type == 'SERVICE')
                        this.loadingInitial = false;
                        setTimeout(() => {
                            $('.select-2-form').select2();
                        }, 100);
                    }else{
                        this.sAlert('error', resultForm.message)
                    }
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.errorHandler(error)
                });
            },
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataService.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                if(this.$route.name == 'adminServicesCreate') {
                    url = `administrator/service/${this.$route.params.id}`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat Kategori Retribusi baru!'
                }else{
                    url = `administrator/service/${this.$route.params.id}/update/${this.$route.params.id_service}`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate Kategori Retribusi!'
                }

                const storedData = {
                    name: this.dataService.name,
                    form_template_id: this.dataService.form_template_id,
                    price: this.dataService.price,
                    unit: this.dataService.unit,
                    unit_type: this.dataService.unit_type,
                    is_editable_price: this.dataService.is_editable_price ? 1 : 0
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: this.dataService,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'adminServices' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.errorHandler(error)
                });
            }
        },
        async mounted() {
            await this.initialLoad()
            
            // LOAD DATA IF ROUTE IS EDIT
            if(this.$route.name == 'adminServicesEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}administrator/service/${this.$route.params.id}/${this.$route.params.id_service}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.dataService.name = result.data.name
                        this.dataService.price = result.data.price
                        this.dataService.unit = result.data.unit
                        this.dataService.form_template_id = result.data.form_template_id
                        this.dataService.unit_type = result.data.unit_type
                        this.dataService.category_service_item_master_data_id = result.data.category_service_item_master_data_id
                        this.dataService.is_editable_price = result.data.is_editable_price
                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.errorHandler(error)
                });
            }
        }
    }
</script>